<template>
    <div>
        <div class="d-flex">
            <div class="mb-3 me-4">
                <label>{{t.blog.post_categories}}</label>
                <select v-model="selectedPostCategory" class="form-select form-select-sm" @change="select()">
                    <option :value="null">{{t.global.all}}</option>
                    <option v-for="postCategory in postCategories" :key="postCategory.id" :value="postCategory.id">{{postCategory.name}}</option>
                </select>
            </div>
            <div class="mb-3">
                <label>{{t.blog.post_types}}</label>
                <select v-model="selectedType" class="form-select form-select-sm" @change="select()">
                    <option :value="null">{{t.global.all}}</option>
                    <option v-for="(type, index) in config.blog.blog_post_types" :key="index" :value="type">{{t.blog[type]}}</option>
                </select>
            </div>
        </div>
        <div v-if="selectedTags.length" class="mb-3">
            <span>{{t.blog.selected_tags}}:</span>
            <span v-for="tag in selectedTags" :key="tag" class="me-2 btn btn-sm btn-outline-secondary py-0" @click="removeTag(tag)"><i class="fa-solid fa-xmark"></i> #{{tag}}</span>
        </div>
        <masonry
            v-if="loaded && posts.length"
            :cols="window.innerWidth <= 420 ? 1 : (window.innerWidth <= 768 ? 2 : 3)"
            :gutter="20"
            tag="div"
            class="post-grid"
        >
            <div class="item mb-3 bg-light" v-for="post in posts" :key="post.id">
                <a v-if="post.type == 'article'" :href="post.url"><img :src="post.thumbnail" class="w-100" :alt="post.title"></a>
                <img v-else-if="post.type != 'video_news'" :src="post.thumbnail" class="w-100" :alt="post.title">
                <iframe
                    v-else
                    style="min-height: 230px; width: 100%"
                    :src="'https://www.youtube.com/embed/'+post.video"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
                <div class="p-3">
                    <div class="small text-muted mb-2"><i class="fa-regular fa-calendar-days"></i> {{post.formattedDate}}</div>
                    <div class="mb-2">
                        <a v-if="post.type == 'article'" class="h5" :href="post.url">{{post.title}}</a>
                        <span v-else class="h5">{{post.title}}</span>
                        <span class="badge rounded-pill bg-secondary fw-normal ms-1" v-if="post.draft">{{t.global.draft}}</span>
                    </div>
                    <div v-if="post.type == 'article'">{{truncateText(stripTags(post.content), 100)}}</div>
                    <div v-else>{{post.content}}</div>
                    <a v-if="post.type == 'article'" class="btn btn-sm btn-link p-0" :href="post.url">{{t.blog.read_more}}</a>
                    <div class="small text-muted mt-2">
                        <span v-for="tag in post.arrayTags" :key="tag" class="me-2 cursor-pointer text-underline" @click="addTag(tag)">#{{tag}}</span>
                    </div>
                </div>
            </div>
        </masonry>
        <div v-else-if="!loaded" class="d-flex justify-content-center align-items-center" style="min-height:417px">
            <div class="spinner-grow text-muted" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div v-else>
            {{t.blog.no_posts_found}}
        </div>
        <!-- <infinite-loading
            :identifier="infiniteId"
            spinner="waveDots"
            @infinite="getResult">
            <div slot="no-more">{{t.blog.no_more_posts}}</div>
            <div slot="no-results">{{ t.blog.no_posts_found }}</div>
        </infinite-loading> -->
        <Bootstrap5Pagination
            :data="result"
            @pagination-change-page="getResult"
        />
    </div>
</template>

<script>
import VueMasonry from "vue-masonry-css";
// import InfiniteLoading from "vue-infinite-loading";
import Bootstrap5Pagination from 'laravel-vue-pagination';
export default {
    components: {
        // InfiniteLoading,
        VueMasonry,
        Bootstrap5Pagination,
    },
    data() {
        return {
            window: window,
            config: config,
            t: t,
            postCategories: postCategories,
            page: window.page ? window.page : 1,
            posts: [],
            selectedTags: window.tags ? window.tags : [],
            selectedType: window.type ? window.type : null,
            selectedPostCategory: window.post_category ? window.post_category : null,
            result: {},
            loaded: false,
            // infiniteId: +new Date(),
        }
    },
    mounted() {
        this.getResult(page)
    },
    methods: {
        removeTag(tag) {
            this.selectedTags.splice(this.selectedTags.indexOf(tag), 1)
            this.posts = []
            // this.page = 1
            this.getResult(1)
            // this.infiniteId += 1
        },
        addTag(tag) {
            this.selectedTags.push(tag)
            this.posts = []
            // this.page = 1
            this.getResult(1)
            // this.infiniteId += 1
        },
        select() {
            this.posts = []
            // this.page = 1
            this.getResult(1)
            // this.infiniteId += 1
        },
        // getResult($state) {
        getResult(page = 1) {
            this.loaded = false
            axios
                .get("/ajax/posts", {
                    params: {
                        // page: this.page,
                        page: page,
                        type: this.selectedType,
                        post_category: this.selectedPostCategory,
                        tags: this.selectedTags,
                    },
                })
                .then((response) => {
                    this.result = response.data
                    if (response.data.data.length) {
                        // this.page += 1;
                        // this.posts.push(...response.data.data);
                        // $state.loaded();
                        this.posts = response.data.data;
                    } else {
                        // $state.complete();
                    }
                    this.loaded = true
                    this.changeUrl()
                });
        },
        changeUrl() {
            var url = this.url('blog')
            var stringQueries = []
            if (this.selectedPostCategory) {
                stringQueries.push('post_category='+this.selectedPostCategory)
            }
            if (this.selectedType) {
                stringQueries.push('type='+this.selectedType)
            }
            if (this.selectedTags.length) {
                stringQueries.push('tags='+this.selectedTags.join(','))
            }
            if (this.result.current_page > 1) {
                stringQueries.push('page='+this.result.current_page)
            }
            history.replaceState(
                {},
                null,
                url+(stringQueries.length ? '?'+stringQueries.join('&') : '')
            )
        }
    }
}
</script>
